import axios from "axios";
import authHeader from "./auth-header";

const API_URL = process.env.REACT_APP_API_URL;

export const getPublicContent = () => {
  return axios.get(API_URL + "all");
};

export const getUserBoard = () => {
  console.log('API_URL :>> ', API_URL);
    //@ts-ignore
  return axios.get(API_URL + "profile", { headers: authHeader() });
};

export const getModeratorBoard = () => {
    //@ts-ignore
  return axios.get(API_URL + "mod", { headers: authHeader() });
};

export const getAdminBoard = () => {
    //@ts-ignore
  return axios.get(API_URL + "admin", { headers: authHeader() });
};